import { Box, Typography, Grid, Chip } from "@mui/material";
import "../../css/common/progressBar.css";

const ProgressBarHorizontal = ({
  valuesPercentages = [],
  onClickChip = () => {},
}) => {
  const renderChip = (label, color, idKey = null) => (
    <Chip
      key={label}
      label={label}
      onClick={onClickChip(idKey || label)}
      className="ProgressBar-Chip"
      style={{
        background: color,
        fontWeight: "bold",
        minWidth: "6rem",
        textAlign: "center",
      }}
    />
  );

  return (
    <Grid
      container
      gap={2}
      margin="2rem 0"
      justifyContent="space-evenly"
      md={12}
    >
      {/* Chip para limpiar */}
      {renderChip("Limpiar filtros", "#8080805e", "active")}

      {/* Chips por categoría */}
      {valuesPercentages.map((value) => (
        <Box
          key={value.idKey}
          onClick={onClickChip(value)}
          className="ProgressBar-Chip"
        >
          {renderChip(value.name, value.color, value.idKey)}
        </Box>
      ))}

      {/* Chip de vencidos */}
      {renderChip("Vencidos", "#EF9A9A", "vencidos")}

      {/* Barra de porcentaje */}
      <Box
        sx={{
          display: "flex",
          width: "100%",
          height: 46,
          borderRadius: 10,
          overflow: "hidden",
          background: "gray",
        }}
      >
        {valuesPercentages.map((value) => (
          <Box
            key={`bar-${value.idKey}`}
            width={value.porcentaje}
            bgcolor={value.color}
            display="flex"
            alignItems="center"
            justifyContent="center"
            px={8}
          >
            <Typography textAlign="center" fontWeight="bold">
              {value.porcentaje}
            </Typography>
            <Typography textAlign="center" fontWeight="bold">
              ({value.cantidad})
            </Typography>
          </Box>
        ))}
      </Box>
    </Grid>
  );
};

export default ProgressBarHorizontal;
